import {
  layoutAtom,
  widgetPanelVisibilityAtom,
  Tabs as MetricPanelTabs,
  activeTabAtom,
  percentileAtom,
  yScaleModeAtom,
} from '@src/components/metrics-panel-hz/atoms';
import { aeRouteKey, trendsRouteKey } from '@src/utils/persistenceUtil';
import {
  globalFilterRulesExpandedAtom,
  globalFilterAppendedAtomStatusAtom,
} from '@src/components/filter/global-atoms';
import { get } from 'lodash';
import { getFeature } from '@src/globalStore/featureStore';
import featureNames from '@src/utils/featureToggle/constants';
import { currentKpiIdAtom } from '@src/atoms/panels';

function genApplyForAtomPersistence({ configuration, pageKey }) {
  // wrapped initStore
  return (store) => {
    if (store) {
      // enable widgets only for main trends and presets that have widget panel enabled
      const isWidgetPanelVisible = get(
        configuration,
        ['metricPanel', 'widgetPanelVisibility'],
        false,
      );
      let widgetPanelVisibility =
        [trendsRouteKey, aeRouteKey].includes(pageKey) || isWidgetPanelVisible;
      const widgetPanelEnabled = getFeature(featureNames.WIDGET_PANEL);
      const defaultMetricPanelTab =
        widgetPanelVisibility && widgetPanelEnabled
          ? MetricPanelTabs.Widgets
          : MetricPanelTabs.MetricCharts;

      if ('atomState' in configuration) {
        const atomState = get(configuration, ['atomState'], null);
        if (atomState) {
          const metricPanel = get(atomState, ['metricPanel'], {});
          const {
            layout = '4s',
            activeTab = defaultMetricPanelTab,
            widgetPanelVisibility: widgetPanelVisibilityInAtom = false,
            percentile = 'avg',
            yScaleMode = false,
          }: any = metricPanel;
          widgetPanelVisibility = widgetPanelVisibility || widgetPanelVisibilityInAtom;
          store.set(layoutAtom, layout);
          store.set(activeTabAtom, activeTab);
          store.set(percentileAtom, percentile);
          store.set(yScaleModeAtom, yScaleMode);
          store.set(globalFilterRulesExpandedAtom, atomState.globalFilterRulesExpanded ?? true);
          store.set(
            globalFilterAppendedAtomStatusAtom,
            atomState.globalFilterAppendedAtomStatus ?? 'dimension',
          );
          // store.set(currentKpiIdAtom, atomState.currentKpiId);
          store.set(currentKpiIdAtom, atomState.currentKpiIdSelected);
        }
      } else {
        // where there is no persisted data
        store.set(activeTabAtom, defaultMetricPanelTab);
      }

      store.set(widgetPanelVisibilityAtom, widgetPanelVisibility);
    }
  };
}

export default genApplyForAtomPersistence;
